import { apiClient } from '@store/index';
import { axiosErrorMiddleware } from './common';

// if the role is null, the role will be removed instead
export const assignWorkspaceRole = async ({
  serviceId,
  userId,
  roleId,
}: {
  serviceId: string;
  userId: string;
  roleId: string | null;
}) => {
  try {
    if (roleId === null) {
      const response = await apiClient.delete(`/${serviceId}/users/${userId}/role`);
      if (response.data.error) throw new Error(JSON.stringify(response.data.error));
      return response.data;
    }

    const response = await apiClient.post(`/${serviceId}/users/${userId}/role/${roleId}`);
    if (response.data.error) throw new Error(JSON.stringify(response.data.error));
    return response.data;
  } catch (error) {
    return axiosErrorMiddleware(error);
  }
};

export const assignWorkspaceAdmin = async ({ serviceId, userId }: { serviceId: string; userId: string }) => {
  try {
    const response = await apiClient.post(`/${serviceId}/users/${userId}/role/admin`);
    if (response.data.error) throw new Error(JSON.stringify(response.data.error));
    return response.data;
  } catch (error) {
    return axiosErrorMiddleware(error);
  }
};

export const removeWorkspaceAdmin = async ({ serviceId, userId }: { serviceId: string; userId: string }) => {
  try {
    const response = await apiClient.delete(`/${serviceId}/users/${userId}/role/admin`);
    if (response.data.error) throw new Error(JSON.stringify(response.data.error));
    return response.data;
  } catch (error) {
    return axiosErrorMiddleware(error);
  }
};
